/**
 * Splits a string only on the first instance of a given token.
 *
 * @param { string } str The string to split
 * @param { string } token The token to split on
 *
 * @return { string[] }
 */
// eslint-disable-next-line snakecasejs/snakecasejs
export const splitOnFirst = (str, token) => {
  const token_index = str.indexOf(token);
  return [
    str.slice(0, token_index),
    str.slice(token_index + token.length),
  ];
};

/**
 * Converts raw HTML into plain text.
 *
 * The HTML is first rendered to a hidden generated span element, then the text content of the span is returned.
 *
 * @param { string } html_str
 * @return { string }
 */
export const htmlToPlainText = (html_str) => {
  const temp_el = document.createElement('span');
  temp_el.innerHTML = html_str;

  return temp_el.textContent ?? temp_el.innerText;
};

/**
 * Capitalises the first character of the first 'phrase' in `str`.
 *
 * By default will capitalise the first character of a string. By passing `multiple` as `true`,
 * all words will be capitalised.
 *
 * By supplying a custom delimeter, this function can also capitalise arbitary sections of `str`.
 *
 * ```
 * capitalise('hello world, nice day'); // 'Hello world, nice day'
 * capitalise('hello world, nice day', true); // 'Hello World, Nice Day'
 * capitalise('hello world, nice day', true, ', '); // 'Hello world, Nice day'
 * ```
 *
 * @param { string } str The target string
 * @param { boolean } multiple Capitalise _all_ delimeted phrases or just the first instance
 * @param { string } delimiter Substring to split target string on to define phrases
 * @return { string }
 */
export const capitalise = (str, multiple = false, delimiter = ' ') => {
  if (str.length === 0) return str;

  if (!multiple) {
    const first_char = str.search(/\w/);
    return `${first_char > 0 ? str.slice(0, first_char) : ''}${str.charAt(first_char).toUpperCase()}${str.slice(first_char + 1)}`;
  }

  const parts = str.split(delimiter);
  return parts.reduce((str, part) => `${str}${str.length ? delimiter : ''}${capitalise(part)}`, '');
};
